import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GenotypingParameterUtilService } from '../shared/genotyping/genotyping-parameter-util.service';
import { CropGenotypingParameter } from '../shared/crop/model/crop-genotyping-parameter';
import { GenotypingBrapiService } from '../shared/brapi/service/genotyping-brapi.service';
import { ParamContext } from '../shared/service/param.context';
import { JhiLanguageService } from '../shared/core-utils';

@Component({
    selector: 'jhi-high-density',
    templateUrl: './high-density.component.html'
})
export class HighDensityComponent implements OnInit {

    version: string;

    cropGenotypingParameter: CropGenotypingParameter;
    isLoading = true;

    constructor(private router: Router,
                private languageService: JhiLanguageService,
                private paramContext: ParamContext,
                private genotypingBrapiService: GenotypingBrapiService,
                private genotypingParameterUtilService: GenotypingParameterUtilService
    ) {
        this.paramContext.readParams();
    }

    ngOnInit(): void {
        const currentLang = this.languageService.getCurrentLanguage();
        this.languageService.changeLanguage(currentLang);

        this.genotypingParameterUtilService.getGenotypingParametersAndAuthenticate().subscribe(
            (cropGenotypingParameter) => {
                this.cropGenotypingParameter = cropGenotypingParameter;
                this.genotypingBrapiService.brapiEndpoint = this.removeTrailingSlash(cropGenotypingParameter.endpoint);
                this.genotypingBrapiService.baseUrl = this.removeTrailingSlash(cropGenotypingParameter.baseUrl);
                this.genotypingBrapiService.accessToken = this.removeTrailingSlash(cropGenotypingParameter.accessToken);

                if (this.genotypingBrapiService.baseUrl) {
                    this.isLoading = false;
                    window.open(this.genotypingBrapiService.baseUrl, '_blank');
                }
            }, (error) => {
                this.isLoading = false;
            });
    }

    removeTrailingSlash(url: string): string {
        return url.replace(/\/+$/, '');
    }
}
